import { NgModule, APP_INITIALIZER, ApplicationInitStatus } from '@angular/core';
import { StpAppModule } from '../stp-app/stp-app.module';

import { StpMaterialModule } from './material/material.module';
import { StpLayoutsModule } from './layouts/layouts.module';
import { StpDataTableModule } from './data-table/data-table.module';
import { StpInputModule } from './input/input.module';
import { StpLookupsModule } from './lookups/lookups.module';
import { StpDatePickerModule } from './date-picker/date-picker.module';
import { StpCheckboxModule } from './checkbox/checkbox.module';
import { StpFieldModule } from './field/field.module';
import { StpSelectModule } from './select/select.module';
import { BusyService } from './services/busy.service';

@NgModule({
  imports: [
    StpAppModule,
    StpMaterialModule,
    StpLayoutsModule,
    StpDataTableModule,
    StpInputModule,
    StpLookupsModule,
    StpDatePickerModule,
    StpCheckboxModule,
    StpFieldModule
  ],
  exports: [
    StpMaterialModule,
    StpLayoutsModule,
    StpDataTableModule,
    StpInputModule,
    StpLookupsModule,
    StpDatePickerModule,
    StpCheckboxModule,
    StpFieldModule,
    StpSelectModule
  ],
  declarations: [],
  providers: [ {
    provide: APP_INITIALIZER,
    multi: true,
    deps: [BusyService],
    useFactory: (busyService: BusyService) => {
      return () => {
        busyService.startFullPage();
      };
    }
  }]
})
export class StpAppMaterialModule { }
